import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './components/FilterPanel.css';
import './components/ui/SegmentedControl.css';
import reportWebVitals from './reportWebVitals';
import { ensureRuntimeConfig } from './runtimeConfig';
import { ensurePartnerTheme } from './theme/partnerTheme';

const bootstrap = async () => {
  try {
    await ensureRuntimeConfig();
  } catch (err) {
    console.warn('Failed to load runtime config.', err);
  }

  // Resolve + apply any partner white-label theme before first paint so there
  // is no flash of the default house branding.
  try {
    await ensurePartnerTheme();
  } catch (err) {
    console.warn('Failed to apply partner theme.', err);
  }

  const [{ default: App }, { AuthProvider }] = await Promise.all([
    import('./App'),
    import('./auth/AuthContext')
  ]);

  const rootElement = document.getElementById('root');
  if (!rootElement) {
    return;
  }

  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <AuthProvider>
        <App />
      </AuthProvider>
    </React.StrictMode>
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
};

bootstrap();
